import { useState, FormEvent } from "react";
import Main from "./Main"; // Import your Main component
import logo from "./assets/logo512S.png";

type Props = {};

export default function App({}: Props) {
  const [password, setPassword] = useState<string>("");
  const [passwordPassed, setPasswordPassed] = useState<boolean>(false);

  const checkPassword = (event: FormEvent) => {
    event.preventDefault();
    if (password === "thought") {
      setPasswordPassed(true);
    } else {
      alert("Incorrect password");
    }
  };

  return passwordPassed ? (
    <Main />
  ) : (
    <div className="flex flex-col items-center justify-center min-h-screen space-y-3">
      <img
        src={logo}
        className="object-contain rounded-md shadow-md h-52 w-52"
        alt="logo"
      />
      <div className="text-3xl font-semibold">Thoughtfolio.ai</div>
      <form onSubmit={checkPassword}>
        <input
          type="password"
          className="px-3 py-2 border rounded-md outline-none"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter Password"
        />
      </form>
    </div>
  );
}
